import AuthService from '../oauth/service'
import ConfigAuth from '../config/config'
import clone from 'lodash/clone'
import intersection from 'lodash/intersection'

class OAuth {
    constructor() {
        this.Session = localStorage
    }

    logout() {
        this.Session.removeItem('access_token');
        this.Session.removeItem('refresh_token');
        AuthService.destroySession()
    }

    guest() {
        return this.Session.getItem('access_token') == null
    }

    isAuthenticated() {
        return this.Session.getItem('access_token') != null
    }

    checkIfHasPermission(permissions) {
        if (AuthService.user) {
            const user = AuthService.user.data.data;
            if (user) {
                let p = clone(user.permissions);
                p = p.map(r => {
                    return r.name;
                });


                if (user.roles[0].name === "Super Admin") {
                    return true;
                } else {
                    for (let i = 0; i < p.length; i++) {
                        if (permissions !== undefined) {
                            if (typeof permissions === "object") {
                                for (let j = 0; j < permissions.length; j++) {
                                    if (p[i].trim() === permissions[j].trim()) {
                                        return true
                                    }
                                }
                            } else {
                                if (p[i].trim() === permissions.trim())
                                    return true
                            }

                        }

                    }
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    }


    checkIfHasRoles(roles) {
        if (AuthService.user) {
            const user = AuthService.user.data.data;
            if (user) {
                let p = clone(user.roles);
                p = p.map(r => {
                    return r.name;
                });

                for (let i = 0; i < p.length; i++) {
                    if (roles !== undefined) {
                        if (typeof roles === "object") {
                            for (let j = 0; j < roles.length; j++) {
                                if (p[i].trim() === roles[j].trim()) {
                                    return true
                                }
                            }
                        } else {
                            if (p[i].trim() === roles.trim())
                                return true
                        }

                    }

                }
                return false;
            } else {
                return false;
            }
        } else {
            return false;
        }


    }

    login(username, password, verification_code = null, provider = 'users') {
        let data = {
            username,
            password,
            verification_code,
            provider
        };
        // We merge grant type and client secret stored in configuration
        data = Object.assign(data, ConfigAuth.oauth);

        return new Promise((resolve, reject) => {
            AuthService.attemptLogin(data).then(response => {
                this.storeSession(response.data);
                this.addAuthHeaders();
                resolve(response)
            }).catch(error => {
                console.log('OAUTH Authentication error: ', error);
                reject(error)
            })
        })
    }

    validate2FAToken(username, password,verification_code= null) {
        let data = {
            username,
            password,
            verification_code
        };
        return new Promise((resolve, reject) => {
            AuthService.validate2FAToken(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
    check2FAEnabled(username, password) {
        let data = {
            username,
            password,
        };
        return new Promise((resolve, reject) => {
            AuthService.attemptCheck2FAEnabled(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }

    reset(username) {
        let data = {
            username,
        };
        // We merge grant type and client secret stored in configuration
        Object.assign(data, ConfigAuth.oauth);

        return new Promise((resolve, reject) => {
            AuthService.attemptReset(data).then(response => {
                resolve(response)
            }).catch(error => {
                console.log('OAUTH reset error: ', error);
                reject(error)
            })
        })
    }

    getUser() {
        if (this.Session.getItem('access_token') != null) {
            return new Promise((resolve, reject) => {
                AuthService
                    .currentUser()
                    .then(response => {
                        resolve(response)
                    }).catch(error => {
                    reject(error)
                })
            })
        }
        return new Promise(resolve => resolve(null))
    }

    getAuthHeader() {
        if (this.Session.getItem('access_token') != null) {
            let accessToken = this.getItem('access_token');
            return ConfigAuth.oauth_type + ' ' + accessToken
        }
        return null
    }

    getItem(key) {
        return this.Session.getItem(key)
    }

    addAuthHeaders() {
        let header = this.getAuthHeader();
        AuthService.addAuthorizationHeader(header)
    }

    storeSession(data) {
        let t = new Date();
        t.setSeconds(t.getSeconds() + data.expires_in);
        this.Session.setItem('expires_in', t);
        this.Session.setItem('access_token', data.access_token);
        this.Session.setItem('refresh_token', data.refresh_token)
    }
}

export default OAuth
